// import { getZoomOffset } from './panAndZoom.util';
import {
  PanAndZoomStoreState,
  PanAndZoomStoreActionType,
  PanAndZoomStoreAction,
  MAX_ZOOM,
  MIN_ZOOM,
} from './panAndZoomStore.types';

export const initialState: PanAndZoomStoreState = {
  translateX: 0,
  translateY: 0,
  prevMouseX: 0,
  prevMouseY: 0,
  scale: 1,
  prevZoomAddition: 0.1,
  prevZoomDirection: 0,
  stepZoomAddition: 0.1,
};

export const reducer = (
  state: PanAndZoomStoreState,
  action: PanAndZoomStoreAction
): PanAndZoomStoreState => {
  switch (action.type) {
    case PanAndZoomStoreActionType.PAN_START:
      return {
        ...state,
        prevMouseX: action.clientX ?? state.prevMouseX,
        prevMouseY: action.clientY ?? state.prevMouseY,
      };
    case PanAndZoomStoreActionType.PAN: {
      const deltaMouseX =
        ((action.clientX ?? state.prevMouseX) - state.prevMouseX) / state.scale;
      const deltaMouseY =
        ((action.clientY ?? state.prevMouseY) - state.prevMouseY) / state.scale;

      const newTranslateX = state.translateX + deltaMouseX;
      const newTranslateY = state.translateY + deltaMouseY;
      const moveXAllowed = action.innerElement
        ? Math.abs(newTranslateX) < action.innerElement.clientWidth / 2
        : true;
      const moveYAllowed = action.innerElement
        ? Math.abs(newTranslateY) < action.innerElement.clientHeight / 2
        : true;

      return {
        ...state,
        // + deltaMouseX
        translateX: moveXAllowed ? newTranslateX : state.translateX,
        // + deltaMouseY
        translateY: moveYAllowed ? newTranslateY : state.translateY,
        prevMouseX: action.clientX ?? state.prevMouseX,
        prevMouseY: action.clientY ?? state.prevMouseY,
      };
    }
    case PanAndZoomStoreActionType.ZOOM: {
      const zoomDirection = action.deltaY ? action.deltaY : 0;
      const zoomDirectionChanged = state.prevZoomDirection !== zoomDirection;
      // When the direction changed the last zoom value should be applied
      // Else a new value should be calculated to zoom dynamically
      const zoomAddition =
        Math.round(
          (zoomDirectionChanged
            ? state.prevZoomAddition
            : state.prevZoomAddition +
              -zoomDirection * state.stepZoomAddition) * 10
        ) / 10;
      const newZoom =
        Math.round((state.scale + -zoomDirection * zoomAddition) * 10) / 10;
      const zoomAllowed =
        newZoom <= MAX_ZOOM && newZoom >= MIN_ZOOM && zoomAddition > 0;
      // const scaledTranslate = getScaledTranslate(state, state.prevZoomAddition);
      // const mousePositionOnScreen = {
      //   x: action.clientX ?? state.prevMouseX,
      //   y: action.clientY ?? state.prevMouseY,
      // };
      // const zoomOffset = getZoomOffset(
      //   mousePositionOnScreen,
      //   state.prevZoomAddition,
      //   action.containerRect
      // );
      return {
        ...state,
        scale: zoomAllowed ? newZoom : state.scale,
        // translateX: scaledTranslate.x + zoomOffset.x,
        // translateY: scaledTranslate.y + zoomOffset.y,
        prevZoomAddition: zoomAllowed ? zoomAddition : state.prevZoomAddition,
        prevZoomDirection: zoomDirection,
      };
    }
    case PanAndZoomStoreActionType.RESET: {
      return {
        ...state,
        ...initialState,
      };
    }
    default:
      return state;
  }
};

// const getScaledTranslate = (
//   state: PanAndZoomStoreState,
//   prevZoomAddition: number
// ): { x: number; y: number } => ({
//   x: state.translateX + prevZoomAddition,
//   y: state.translateY + prevZoomAddition,
// });
